// extracted by mini-css-extract-plugin
export default {"statsBar":"StatsBar_statsBar__bo8GE","statItem":"StatsBar_statItem__dM7v+","statNum":"StatsBar_statNum__waRtN","statLabel":"StatsBar_statLabel__b0GVe"};